import { render, staticRenderFns } from "./other-share.vue?vue&type=template&id=9cd05bf2&scoped=true&"
import script from "./other-share.vue?vue&type=script&lang=js&"
export * from "./other-share.vue?vue&type=script&lang=js&"
import style0 from "./other-share.vue?vue&type=style&index=0&id=9cd05bf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cd05bf2",
  null
  
)

export default component.exports